import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [],total:0,error: "", message: "" }


export const getPostbackAction = createAsyncThunk(
    'get-postback',
    async (data, { rejectWithValue }) => {
        try {
            const params = new URLSearchParams();
            if (data.page !== undefined && data.page !== null) params.append('page', data.page);
            if (data.limit !== undefined && data.limit !== null) params.append('limit', data.limit);
            if (data.startDate && data.startDate !== 'undefined' && data.startDate !== null) params.append('startDate', data.startDate);
            if (data.endDate && data.endDate !== 'undefined' && data.endDate !== null) params.append('endDate', data.endDate);
            
            const res = await axios.get(`/admins/api/postback/logs?${params.toString()}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getPostbackSlice = createSlice({
    name: 'get-postback',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getPostbackAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getPostbackAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.totalData
            })
            builder.addCase(getPostbackAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.totalData

            })
        },

})



export const getPostbackReducer = getPostbackSlice.reducer